// extracted by mini-css-extract-plugin
export default {"severity-3":"AuditStatus_severity-3__rE8pb","severity-2":"AuditStatus_severity-2__xWZ8Z","severity-0":"AuditStatus_severity-0__bPnFP","severity-1":"AuditStatus_severity-1__i86MH"};